import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { BancoNoticiasService } from "src/app/services/banco-noticias.service";
import { obterArquivoPdfNoticia, obterArquivoPdfNoticiaFailure, obterArquivoPdfNoticiaSuccess } from "../../actions/BancoNoticias/obter-arquivo-pdf-noticia.action";

@Injectable()
export class ObterArquivoPdfNoticiaEffects {

  public obterArquivoPdfNoticia$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly bancoNoticiasService: BancoNoticiasService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterArquivoPdfNoticia$ = createEffect(() => this.actions$.pipe(
      ofType(obterArquivoPdfNoticia),
      switchMap(({ inputDto }) =>
        this.bancoNoticiasService
          .obterArquivoPdfNoticia(inputDto)
          .pipe(
            map(
              response => {
              if (response.erros != undefined && response.erros.length > 0) {
                return obterArquivoPdfNoticiaFailure({ response })
              }
              return obterArquivoPdfNoticiaSuccess({ response })
            }),
            catchError(() => {
              return of()}
            )
          )
      )
    )
    );
  }
}
